// ============================================================
//  FIREBASE CLIENT — env-basiert, projektunabhängig (revyne-Vorlage)
//  Alle Werte kommen aus .env (siehe .env.example).
//  NIE Firebase-Config hier hart hineinschreiben — sonst ist diese
//  Datei nicht mehr als Vorlage für andere Kundenprojekte nutzbar.
// ============================================================
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

if (!firebaseConfig.apiKey) {
  // Frühwarnung statt kryptischem Firebase-Fehler tief im Code.
  console.error(
    "[firebase.js] VITE_FIREBASE_API_KEY fehlt. .env prüfen (siehe .env.example)."
  );
}

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
